/**
 * mk-material-center
 * unknown
 *
 * OpenAPI spec version: last
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import ajax, { AjaxPromise, ExtraFetchParams } from '@ajax';
import * as models from '../model/models';

/* tslint:disable:no-unused-variable member-ordering object-literal-shorthand */

/**
  * @description v1AuthUserContactMeDetailGet参数
  * @property `type` 1联系人信息 2授权信息
  */
export interface Paramsv1AuthUserContactMeDetailGet {
  // queryParams
  /**
   * 1联系人信息 2授权信息
   */
  type: string;
}
/**
  * @description v1UserContactMeDetailGet参数
  * @property `[userId]` 通讯录成员ID
  * @property `qwUserId` 企微用户ID
  * @property `materialId` 素材ID
  * @property `corpId` 公司 corpID
  * @property `cid` 公司ID
  * @property `type` 1联系人信息 2授权信息
  */
export interface Paramsv1UserContactMeDetailGet {
  // queryParams
  /**
   * 通讯录成员ID
   */
  userId?: string;
  /**
   * 企微用户ID
   */
  qwUserId: string;
  /**
   * 素材ID
   */
  materialId: string;
  /**
   * 公司 corpID
   */
  corpId: string;
  /**
   * 公司ID
   */
  cid: string;
  /**
   * 1联系人信息 2授权信息
   */
  type: string;
}

export class UserApi {
  protected $basePath = '/material/center'.replace(/\/$/, '');

  public constructor(basePath?: string) {
    if (basePath !== undefined) {
      this.$basePath = basePath.replace(/\/$/, '');
    }
  }

  /**
   * 
   * @summary [带鉴权]查询销售详情，包括二维码，图片，手机号码，邮箱等
   * @param params Paramsv1AuthUserContactMeDetailGet
   
   * @param opt ajax config
   * @returns models.V1AuthUserContactMeDetail
   */
  public v1AuthUserContactMeDetailGet = (
    params: Paramsv1AuthUserContactMeDetailGet,
    opt?: ExtraFetchParams
  ) : AjaxPromise<models.V1AuthUserContactMeDetail>  => {
    const path = '/v1/auth_user/contact_me/detail';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('type' in params) p.query.type = params.type;
    ajax.check(params.type, 'type');
    return ajax.ajax({
      ...opt,
      method: 'GET',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary 查询销售详情，包括二维码，图片，手机号码，邮箱等
   * @param params Paramsv1UserContactMeDetailGet
   
   * @param opt ajax config
   * @returns models.V1AuthUserContactMeDetail
   */
  public v1UserContactMeDetailGet = (
    params: Paramsv1UserContactMeDetailGet,
    opt?: ExtraFetchParams
  ) : AjaxPromise<models.V1AuthUserContactMeDetail>  => {
    const path = '/v1/user/contact_me/detail';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('userId' in params) p.query.userId = params.userId;
    if ('qwUserId' in params) p.query.qwUserId = params.qwUserId;
    ajax.check(params.qwUserId, 'qwUserId');
    if ('materialId' in params) p.query.materialId = params.materialId;
    ajax.check(params.materialId, 'materialId');
    if ('corpId' in params) p.query.corpId = params.corpId;
    ajax.check(params.corpId, 'corpId');
    if ('cid' in params) p.query.cid = params.cid;
    ajax.check(params.cid, 'cid');
    if ('type' in params) p.query.type = params.type;
    ajax.check(params.type, 'type');
    return ajax.ajax({
      ...opt,
      method: 'GET',
      url,
      ...p
    });
  }
}

export default new UserApi();